export { default } from './DataCentre';



// WEBPACK FOOTER //
// ./src/pages/DataCenter/index.ts